import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { setNotesFilter } from "../../../store/NotesStore";

const NotesListFilterController = () => {
    const dispatch = useDispatch();
    const [searchParams, _] = useSearchParams()

    useEffect(() => {
        var params = {};
        if (searchParams.has("categoryId")) {
            let categoryId = searchParams.get("categoryId");
            params = {...params, categoryId};
            dispatch(setNotesFilter(params))
        }
        if (searchParams.has("tagId")) {
            let tagId = searchParams.get("tagId");
            params = {...params, tagId};
            dispatch(setNotesFilter(params))
        }
        // dispatch(setNotesFilter(params))
    }, [searchParams]);

    return (<></>);
}

export default NotesListFilterController;